export const draftAfterContactChange = (draft, change)=>{
    switch(change.type){
        case 'noContact':
            return draft.clientContactId() ? draft.setClientContactId(null) : null;
        case 'sampleContact':
            return draft.setSampleContact();
        case 'existingContact':
            return draft.setClientContactId(change.id);
    }
};
